"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CycleCountHistory = void 0;
const router_1 = require("client/components/router");
const store_1 = require("client/modules/sites/modules/sites-detail/store");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = require("react");
const React = require("react");
const edit_cycle_count_history_1 = require("../../components/edit-cycle-count-history");
require("./cycle-count-history.less");
let CycleCountHistory = class CycleCountHistory extends react_1.Component {
    constructor() {
        super(...arguments);
        this.showCycleCountReview = false;
        this.handleCancel = () => {
            router_1.RouteManager.transitionTo("/lots/pharmacies");
        };
    }
    async componentDidMount() {
        const siteId = this.props.params[0];
        // if (siteId) {
        //   await stocksStore.loadCycleCounts(siteId);
        // }
    }
    handleSave() {
        alert("implement me");
    }
    render() {
        return (React.createElement("div", { className: "sites__form" },
            React.createElement(edit_cycle_count_history_1.EditCycleCountHistory, { error: store_1.sitesDetailStore.inventorysites.error, loading: store_1.sitesDetailStore.site.loading, status: store_1.sitesDetailStore.site.status, onCancel: this.handleCancel, onSave: this.handleSave, site: store_1.sitesDetailStore.site.value })));
    }
};
__decorate([
    mobx_1.observable
], CycleCountHistory.prototype, "showCycleCountReview", void 0);
CycleCountHistory = __decorate([
    mobx_react_1.observer
], CycleCountHistory);
exports.CycleCountHistory = CycleCountHistory;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/stocks/modules/sites-detail/tabs/cycle-count-history/cycle-count-history.tsx
// module id = 4109
// module chunks = 0